module.exports = {
	"name": "wup-teachers-desk",
	"version": "0.1.0",
	"private": true,
	"devDependencies": {
		"autoprefixer": "6.5.1",
		"autoprefixer-loader": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "6.17.0",
		"babel-jest": "17.0.2",
		"babel-loader": "6.2.7",
		"babel-plugin-transform-class-properties": "6.24.1",
		"babel-plugin-transform-decorators-legacy": "1.3.4",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-react-app": "^2.0.1",
		"case-sensitive-paths-webpack-plugin": "1.1.4",
		"chalk": "1.1.3",
		"connect-history-api-fallback": "1.3.0",
		"cross-spawn": "4.0.2",
		"css-loader": "^0.26.1",
		"detect-port": "1.0.1",
		"dotenv": "2.0.0",
		"extract-text-webpack-plugin": "1.0.1",
		"file-loader": "0.9.0",
		"filesize": "3.3.0",
		"fs-extra": "0.30.0",
		"gzip-size": "3.0.0",
		"html-webpack-plugin": "2.24.0",
		"http-proxy-middleware": "0.17.2",
		"jest": "17.0.2",
		"json-loader": "0.5.4",
		"node-sass": "^4.14.1",
		"node-sass-importer": "^1.0.0",
		"normalize.css": "^5.0.0",
		"object-assign": "4.1.0",
		"path-exists": "2.1.0",
		"postcss-loader": "1.0.0",
		"promise": "7.1.1",
		"react-dev-utils": "^0.4.2",
		"recursive-readdir": "2.1.0",
		"sass-loader": "^4.1.1",
		"strip-ansi": "3.0.1",
		"style-loader": "^0.13.1",
		"url-loader": "0.5.7",
		"webpack": "1.14.0",
		"webpack-dev-server": "1.16.2",
		"webpack-manifest-plugin": "1.1.0",
		"whatwg-fetch": "1.0.0"
	},
	"dependencies": {
		"@elastic/apm-rum": "^5.12.0",
		"@sentry/browser": "5.30.0",
		"babel-plugin-transform-decorators-legacy": "^1.3.4",
		"chart.js": "^2.6.0",
		"classnames": "^2.2.5",
		"dropbox": "^10.34.0",
		"exif-js": "^2.1.1",
		"exifjs": "^1.1.2",
		"jquery": "^3.2.1",
		"mobx": "^3.1.16",
		"mobx-react": "^4.1.0",
		"mobx-react-router": "^3.1.1",
		"moment": "^2.17.1",
		"moment-timezone": "^0.5.13",
		"prop-types": "^15.5.10",
		"qrcode-generator": "^1.4.4",
		"rc-progress": "^2.2.1",
		"react": "^15.6.1",
		"react-addons-css-transition-group": "^15.4.2",
		"react-day-picker": "^3.1.1",
		"react-dom": "^15.4.2",
		"react-input-mask": "^0.8.0",
		"react-maskedinput": "^3.3.4",
		"react-modal": "^3.1.7",
		"react-qr-reader": "^1.1.3",
		"react-router": "^3.0.0",
		"react-select": "^1.0.0-rc.10",
		"react-transition-group": "^1.2.0"
	},
	"scripts": {
		"start": "node scripts/start.js",
		"build": "node scripts/build.js",
		"test": "node scripts/test.js --env=jsdom"
	},
	"jest": {
		"collectCoverageFrom": [
			"src/**/*.{js,jsx}"
		],
		"setupFiles": [
			"<rootDir>/config/polyfills.js"
		],
		"testPathIgnorePatterns": [
			"<rootDir>[/\\\\](build|docs|node_modules)[/\\\\]"
		],
		"testEnvironment": "node",
		"testURL": "http://localhost",
		"transform": {
			"^.+\\.(js|jsx)$": "<rootDir>/node_modules/babel-jest",
			"^.+\\.css$": "<rootDir>/config/jest/cssTransform.js",
			"^(?!.*\\.(js|jsx|css|json)$)": "<rootDir>/config/jest/fileTransform.js"
		},
		"transformIgnorePatterns": [
			"[/\\\\]node_modules[/\\\\].+\\.(js|jsx)$"
		],
		"moduleNameMapper": {
			"^react-native$": "react-native-web"
		}
	},
	"babel": {
		"presets": [
			"react-app"
		],
		"plugins": [
			"transform-decorators-legacy",
			"transform-class-properties"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 236
// module chunks = 0